import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

import { PickupRequestListMaterial } from "../../types";

import styles from "./MaterialsList.module.scss";

interface Props {
  materials: PickupRequestListMaterial[];
  showTotal?: boolean;
  className?: string;
}

const MaterialsList = (props: Props) => {
  const { materials, showTotal = false, className } = props;
  const { t } = useTranslation();

  if (!materials.length) {
    return (
      <div className={classnames(styles.materialsList, className)}>
        <span className={styles.empty}>
          {t("pickupRequests.materials.empty")}
        </span>
      </div>
    );
  }

  const total = materials.reduce((sum, material) => sum + material.amount, 0);

  return (
    <div className={classnames(styles.materialsList, className)}>
      {materials.map((material, index) => (
        <div className={styles.row} key={`${material.code}-${index}`}>
          <span className={styles.code}>
            {t(`pickupRequests.materials.codes.${material.code}`, {
              defaultValue: material.code,
            })}
          </span>
          <span className={styles.amount}>{material.amount}</span>
        </div>
      ))}
      {showTotal && (
        <div className={classnames(styles.row, styles.total)}>
          <span className={styles.code}>
            {t("pickupRequests.materials.total")}
          </span>
          <span className={styles.amount}>{total}</span>
        </div>
      )}
    </div>
  );
};

export default MaterialsList;
